import { FlowRouteCategory } from '@eneco/flows/types';

import { SummaryStep } from './steps/SummaryStep_C';
import { TestConfigVariant } from '../../types/experiment';

export const exp_n_522_C: TestConfigVariant = {
  testKey: 'exp-n-522-new-summary-step-layout',
  variant: 'C',
  routes: [
    {
      id: 'SUMMARY',
      path: '/je-gegevens/controle-keuze/',
      category: FlowRouteCategory.Summary,
      component: SummaryStep,
    },
  ],
};
